import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./helpCenterMobile.html";
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { selectHelpCenter, WireI18n } from '~/modules/stores/i18nStore';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
import { getUniqueIteratorKey } from '~/modules/utilities/lwcUtilities';
const NEWS_ITEMS = ['agentExchangeSolutions'];
const JAPANESE_NEWS = ['globalNav', 'explore'];
class HelpCenterMobile extends LightningElement {
  constructor(...args) {
    super(...args);
    this.hideTitle = false;
    this.labels = void 0;
  }
  // The V2 mobile detail pane supplies its own padding, so the embedded variant must not add its own.
  get containerClass() {
    return this.hideTitle ? 'help-center-mobile help-center-mobile_flush' : 'help-center-mobile';
  }
  get news() {
    const newsLabels = this.labels?.news;
    if (!newsLabels) {
      return [];
    }
    return NEWS_ITEMS.reduce((newsItems, newsItem) => {
      newsItems.push({
        title: newsLabels[newsItem]?.title,
        text: newsLabels[newsItem]?.text,
        iteratorKey: getUniqueIteratorKey()
      });
      return newsItems;
    }, []);
  }
  get jpNews() {
    const jpNewsLabels = this.labels?.news;
    if (!jpNewsLabels) {
      return [];
    }
    return JAPANESE_NEWS.map(jpNewsItem => ({
      title: jpNewsLabels[jpNewsItem]?.title,
      text: jpNewsLabels[jpNewsItem]?.text,
      iteratorKey: getUniqueIteratorKey()
    }));
  }
  get isJapaneseUserLanguage() {
    return getUserLanguage() === JAPANESE_LANGUAGE_CODE;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(HelpCenterMobile, {
  publicProps: {
    hideTitle: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectHelpCenter
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(HelpCenterMobile, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;